import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@app/environments/environment';

/**
 * Prefix all API requests with `environment.serverUrl`, except for `assets/` requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Exclude translation and other assets requests
    const isAssetRequest = /\/assets\/i18n\/.*\.json$/.test(request.url);
    if (isAssetRequest) {
      return next.handle(request);
    }

    // Prefix other API requests
    request = request.clone({
      url: environment.serverUrl + request.url,
    });
    return next.handle(request);
  }
}
